import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';
import React from 'react';

interface Props {
  color: string;
}

const GripIcon: React.FC<Props> = (props) => <GripIconStyled icon="grip" height={20} width={20} {...props} />;

export default GripIcon;

const GripIconStyled = styled(PolarisIcon)<Props>`
  position: absolute;
  top: ${({ theme }) => theme.spacing(0.25)};
  left: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ color }) => color};
`;
